import { actionTypes as bookmakersListActionTypes } from './bookmakersList.actions';
import updateUserAccountsInfoStorage from '../utils/userAccountsInfo';

export default function bookmakersListItemReducer(bookmaker = {}, action) {
    switch (action.type) {
        case bookmakersListActionTypes.SET_AUTH_INFO:
            return {
                ...bookmaker,
                auth: action.info,
            };
        case bookmakersListActionTypes.SET_LOGGEDIN_BOOKMAKERS:
            return {
                ...bookmaker,
                isLoggedIn: true,
            };
        case bookmakersListActionTypes.USER_INFO_REQUESTING:
            return {
                ...bookmaker,
                userInfoRequesting: true,
            };
        case bookmakersListActionTypes.SET_USER_INFO:
            updateUserAccountsInfoStorage(
                bookmaker,
                bookmaker.isLoggedIn,
            );

            return {
                ...bookmaker,
                userInfoRequesting: false,
                userInfo: {
                    ...action.data,
                    hasDetails: true,
                },
                isLoggedIn: true,
            };
        case bookmakersListActionTypes.SET_USER_INFO_ERROR:
            return {
                ...bookmaker,
                userInfoRequesting: false,
                userInfo: {
                    hasDetails: false,
                    error: action.error,
                },
                isLoggedIn: false,
            };
        case bookmakersListActionTypes.SET_LOGGEDOUT:
            updateUserAccountsInfoStorage(bookmaker, false);

            return {
                ...bookmaker,
                isLoggedIn: false,
            };
        default:
            return bookmaker;
    }
}



// WEBPACK FOOTER //
// /src/js/common/bookmakersList/bookmakersListItem.reducer.js